export default "__VITE_ASSET__CF7mKs8Q__"